import { createFeatureSelector, createSelector } from '@ngrx/store';

import { parentFeatureKey, ParentState } from './parent.reducer';

export const selectParentState = createFeatureSelector<ParentState>(parentFeatureKey);
export const selectChildren = createSelector(selectParentState, state => state?.children);
export const selectClassroomContext = createSelector(selectParentState, state => state?.classroomContext);
export const selectStudentContext = createSelector(selectParentState, state => state?.studentContext);
export const selectChildrenLoaded = createSelector(selectParentState, state => state?.childrenLoaded);
export const selectMessages = createSelector(selectParentState, state => state?.messages || []);

export const selectStudentById = (userId: string) => createSelector(selectChildren, state => (
  state?.find(child => child.userId === userId)
));

export const selectClassroomById = (userId: string, classroomId: string) => createSelector(selectChildren, (state) => {
  const student = state?.find(child => child.userId === userId);
  return student?.classrooms?.find(classroom => classroom.classroomId === classroomId);
});
